import { useSelector } from "react-redux";
import store from "../storeWire";
import {
  download_bom_template,
  fetchBOMList,
  FORCE_remove_bomDetailByBomIDWithType_by_type,
  getBomDetailByBomID,
  getBomDetailByBomIDWithType,
  getBomDetailCountByBomID,
  getBomHealthByBomID,
  updateCustomerPartNumberByBomDetailID,
  SET_bomSortByUpdatedDate, SET_bomMultipleMatchTrigger,
  fetch_static_columns,
  fetch_saved_columns_data_by_bom_id,
  SET_bomDataList_based_on_ROW_selected,
  fetch_bom_project_detail_with_bom,
  fetch_project_list,
  SET_quantity_exact_match_tab_by_bomDetailId,
  getNewarkBomList
} from "../store/slice/model/BOM";
import useReduxState from "./useReduxState";
import BOMAPICall from "src/service/BOMAPICall";
import BOMRepository from "src/repository/BOMRepository";
import Constants from "src/helper/Constants";
import System from "src/helper/system";
import { load_initialState } from "../store/slice/model/BOM/BOMDownloadPopup";
import { load_all_selected_fields, remove_all_selected_fields, toggle_single_selected_fields } from "src/store/slice/model/BOM/BOMExactMatch";

export function useBOMStore() {
  const bom_list = useSelector((state) => state.entities.model_BOM.bomList)
  const bom_detail_by_bom_id = useSelector((state) => state.entities.model_BOM.bomDetailByBomID)
  const bom_health_by_bom_id = useSelector((state) => state.entities.model_BOM.bomHealthByBomID)
  const bom_detail_by_bom_id_type = useSelector((state) => state.entities.model_BOM.bomDetailByBomIDWithType)
  const bom_detail_Exact_list = useSelector((state) => state.entities.model_BOM.bomDetailByBomIDWithType.Exact)
  const bom_detail_Multiple_list = useSelector((state) => state.entities.model_BOM.bomDetailByBomIDWithType.Multiple)
  const bom_detail_NoMatch_list = useSelector((state) => state.entities.model_BOM.bomDetailByBomIDWithType.NoMatch)
  const bomUploadFile__progress_percentage = useSelector((state) => state.entities.model_BOM.bomUploadFile__progress_percentage)
  const bomMultipleMatchTrigger = useSelector((state) => state.entities.model_BOM.bomMultipleMatchTrigger)
  const bomSortByUpdatedDate = useSelector((state) => state.entities.model_BOM.bomSortByUpdatedDate)
  const selected_fields = useSelector((state) => state.entities.model_BOM_BOMExactMatch.selected_fields)
  const dynamic_field_activated = useSelector((state) => state.entities.model_BOM_BOMFieldActivated.BomDetail.ExactMatchPage.dynamic_field_activated)
  const exact_dynamic_field_activated = useSelector((state) => state.entities.model_BOM_BOMFieldActivated.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated)
  const download_selected_fields = useSelector((state) => state.entities.model_BOM_BOMDownloadPopup.selected_fields)
  const export_type = useSelector((state) => state.entities.model_BOM_BOMDownloadPopup.export_type)
  const save_preference = useSelector((state) => state.entities.model_BOM_BOMDownloadPopup.save_preference)
  const { bomDetailPageTabs } = Constants
  const row_selected_number = useSelector((state) => state.entities.model_BOM.row_selected_number)
  const static_columns = useSelector((state) => state.entities.model_BOM.static_columns)
  const bom_data_list = useSelector((state) => state.entities.model_BOM.bomDataList)
  const bom_data_list_main_copy = useSelector((state) => state.entities.model_BOM.bomDataListMainCopy)
  const column_mapping_list = useSelector((state) => state.entities.model_BOM.columnMappingList)
  const [top] = useReduxState({
    NoMatch: { top: 20 },
    Multiple: { top: 20 },
    Exact: { top: 20 }
  }, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT');
  const bomTabType = System.getParams().__c_BomTabList || bomDetailPageTabs.BomExactMatchTable.content;
  const total_bom = useSelector((state) => state.entities.model_BOM.total_bom)
  const bom_project_list = useSelector((state) => state.entities.model_BOM.bomProjectList)
  const your_bom_listing = useSelector((state) => state.entities.model_BOM.yourBomListing)
  const your_bom_listing_with_project = useSelector((state) => state.entities.model_BOM.yourBomListingWithProject)
  const newark_bom_list = useSelector((state) => state.entities.model_BOM.newarkBomList)

  const data = {
    bom_list,
    bom_detail_by_bom_id,
    bom_health_by_bom_id,
    bomUploadFile__progress_percentage,
    bom_detail_by_bom_id_type,
    bom_detail_Exact_list,
    bom_detail_Multiple_list,
    bom_detail_NoMatch_list,
    bomMultipleMatchTrigger,
    bomSortByUpdatedDate,
    selected_fields,
    dynamic_field_activated,
    exact_dynamic_field_activated,
    download_selected_fields,
    export_type,
    save_preference,
    row_selected_number,
    static_columns,
    bom_data_list,
    bom_data_list_main_copy,
    column_mapping_list,
    total_bom,
    bom_project_list,
    your_bom_listing,
    your_bom_listing_with_project,
    newark_bom_list
  };
  const fetch = {
    fetch_bom_list: async (prams) => {
      return await store.dispatch(fetchBOMList(prams))
    },
    fetch_product_category_list: async () => {
      return await new BOMRepository().fetchProductCategoryList();
    },
    get_bom_detail_by_bom_id: async (params) => {
      return await store.dispatch(getBomDetailByBomID(params))
    },
    get_bom_detail_count_by_bom_id: async (params) => {
      return await store.dispatch(getBomDetailCountByBomID(params))
    },
    get_bom_health_by_bom_id: async (params) => {
      return await store.dispatch(getBomHealthByBomID(params))
    },
    get_bom_detail_by_bom_id_with_type: async (params) => {
      return await store.dispatch(getBomDetailByBomIDWithType(params))
    },
    get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui: async (bomId, isAfterAddedPart = false) => {
      Object.entries(bomDetailPageTabs).map(async (v) => {
        store.dispatch(FORCE_remove_bomDetailByBomIDWithType_by_type({
          matchType: v[1].api_fetch_type
        }));
      });

      if (bomTabType) {
        let topHere = 20;
        if (top[bomDetailPageTabs[bomTabType].api_fetch_type] && top[bomDetailPageTabs[bomTabType].api_fetch_type].top) {
          topHere = top[bomDetailPageTabs[bomTabType].api_fetch_type].top
        }

        const param = {
          bomId: bomId,
          isReRunPartMatch: false,
          matchType: bomDetailPageTabs[bomTabType].api_fetch_type,
          top: topHere,
          sortColumn: isAfterAddedPart ? "updated_date" : "sequence_number",
          sortOrder: isAfterAddedPart ? "desc" : "asc"
        }

        if (isAfterAddedPart) {
          store.dispatch(SET_bomSortByUpdatedDate(true));
          param.top = 20
          // param.skip = 0
        }

        await store.dispatch(getBomDetailByBomIDWithType(param));
      }
    },
    bom_upload_file: async (params) => {
      return await new BOMAPICall().bomUploadFile(params);
    },
    fetch_download_file_preference: async (params) => {
      const r = await new BOMRepository().fetchDownloadFilePreference(params);
      store.dispatch(load_initialState(r));
      return r;
    },
    is_part_valid_for_cart: (product, price, inventory) => {
      return new BOMRepository().isPartValidForCart(product, price, inventory)
    },
    get_MultipleMatch_Product_Search: (bomDetailId, getRawData = true) => {
      return new BOMRepository().getMultipleMatchProductSearch(bomDetailId, getRawData = true)
    },
    merge_Guest_Bom_Items: () => {
      return new BOMRepository().mergeGuestBomItem()
    },
    fetch_static_columns: async () => {
      return await store.dispatch(fetch_static_columns())
    },
    fetch_saved_columns_data_by_bom_id: async (params) => {
      return await store.dispatch(fetch_saved_columns_data_by_bom_id(params.bomId))
    },
    fetch_saved_preference_by_bom_id: async (params) => {
      return await new BOMRepository().fetchSavedColumnsPreferenceByBomID(params);
    },
    fetch_bom_project_detail_with_bom: async (params) => {
      return await store.dispatch(fetch_bom_project_detail_with_bom(params))
    },
    fetch_project_list: async () => {
      return await store.dispatch(fetch_project_list())
    },
    fetch_Newark_bom_list: async (params) => {
      return await store.dispatch(getNewarkBomList(params))
  },
  };
  const set = {
    create_bom: async (params) => {
      return await new BOMRepository().createBOM(params)
    },
    create_blank_bom: async () => {
      return await new BOMRepository().createBlankBOM()
    },
    delete_bom_by_bom_id: async (params) => {
      return await new BOMRepository().deleteBOMByBomID(params.bomId)
    },
    copy_bom_by_bom_id: async (params) => {
      return await new BOMRepository().copyBOMByBomID(params)
    },
    edit_bom_name: async (params) => {
      return await new BOMRepository().editBOMName(params.bomName, params.bomId)
    },
    set_is_rematch_flag: async (params) => {
      return await new BOMRepository().setBOMIsRematchFlag(params.bomId)
    },
    add_part_to_bom: async (params) => {
      return await new BOMRepository().addPartToBOM(params)
    },
    create_params_for_add_part_to_bom: (params, fromCart) => {
      return new BOMRepository().createParamsForAddPartToBom(params, fromCart)
    },
    download_bom_template: async () => {
      return await store.dispatch(download_bom_template())
    },
    set_bom_multi_match_trigger: (params) => {
      return store.dispatch(SET_bomMultipleMatchTrigger(params))
    },
    bom_download_file: async (params) => {
      return await new BOMRepository().bomDownloadFile(params.bomId, params.fileType, params.fieldColumns, params.currentCurrency);
    },
    bom_email_file: async (params) => {
      return await new BOMRepository().bomEmailFile(params.bomId, params.fileType, params.fieldColumns, params.recipientEmail, params.senderEmail, params.message, params.currentCurrency);
    },
    create_part_list: async (params) => {
      return await new BOMRepository().createPartList(params.bomIds, params.partList)
    },
    bom_assign_to_project: async (params) => {
      return await new BOMRepository().assignBOMToProject(params.bomId, params.projectId)
    },
    swap_part_number: async (params) => {
      return await new BOMRepository().swapPartNumber(params)
    },
    update_quantity_by_bom_detail_by_id: async (params) => {
      return await new BOMRepository().updateQuantityByBomDetailID(params)
    },
    update_customer_part_number_by_bom_detail_by_id: async (params) => {
      return await store.dispatch(updateCustomerPartNumberByBomDetailID(params))
    },
    remove_part_number: async (params) => {
      return await new BOMRepository().removePartNumber(params.bomDetailId, params.bomId)
    },
    bom_upload_progress: async (params) => {
      return await new BOMAPICall().bomUploadProgress({ bomId: params.bomId })
    },
    update_display_order: async (params) => {
      return await new BOMAPICall().updateDisplayOrder(params)
    },
    save_download_file_preference: async (params) => {
      return await new BOMRepository().saveDownloadFilePreference(params);
    },
    set_saved_columns_preference_by_bom_id: async (params) => {
      return await new BOMRepository().saveColumnsPreferenceByBomID(params);
    },
    SET_bomDataList_based_on_ROW_selected: async (row_selected_number) => {
      return await store.dispatch(SET_bomDataList_based_on_ROW_selected({ row_selected_number }))
    },
    update_bom_exact_match_record_with_cpn_quantity: async (params) => {
      return store.dispatch(SET_quantity_exact_match_tab_by_bomDetailId(params))
    },
    load_all_selected_fields: async (params) => {
      return store.dispatch(load_all_selected_fields(params))
    },
    toggle_single_selected_fields: async (params) => {
      return store.dispatch(toggle_single_selected_fields(params))
    },
    remove_all_selected_fields: async () => {
      return store.dispatch(remove_all_selected_fields())
    },
    USERS_WITH_ABANDONED_BOM_FOR_72_HOURS: async (params) => {
      return await new BOMRepository().UsersWithAbandonedBomFor72Hours(params);
    },
    delete_project: async (params) => {
      return await new BOMRepository().deleteSingleProject(params.projectId)
    },
    edit_project: async (params) => {
      return await new BOMRepository().editProject(params)
    },
    create_project: async (params) => {
      return await new BOMRepository().createProject(params)
    },
    update_Newark_Qte: async (params) => {
      return await new BOMRepository().updateNewarkQte(params)
  },
  };
  return [data, fetch, set]
}